var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "order-return-review-customer-details flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    Review return summary\n  "),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.needsReturnLabel || _vm.needsReturnLabel === null
        ? _c("span", [_vm._m(0)])
        : _c("span", [_vm._m(1)]),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "return-customer-details" },
        [
          _c("el-card", { attrs: { shadow: "never" } }, [
            _c(
              "div",
              { staticClass: "flex flex-col" },
              [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v("\n          Items\n        "),
                ]),
                _c("br"),
                _vm._v(" "),
                _vm._l(_vm.itemsToReturn, function (item, idx) {
                  return _c("div", _vm._b({ key: idx }, "div", item, false), [
                    _vm._v(
                      "\n          x" +
                        _vm._s(item.quantity) +
                        " " +
                        _vm._s(item.title)
                    ),
                    _c("br"),
                    _vm._v(
                      "\n          ASIN: " + _vm._s(item.sku) + "\n        "
                    ),
                  ])
                }),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "summary-header" }, [
                    _vm._v("\n            Customer info\n          "),
                  ]),
                  _c("br"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Name\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.customer_name))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Phone Number\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.customer_phone))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Email\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.customer_email))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-row",
                      staticStyle: { "margin-top": "20px" },
                    },
                    [
                      _c("div", { staticClass: "flex-1" }, [
                        _vm._v("\n              Street\n            "),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.address.address_1) +
                            " " +
                            _vm._s(_vm.address.address_2)
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              City\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.address.city))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v(
                        "\n              State/province/area\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.address.state))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Zip code\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.address.zip))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Country\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.address.country))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "summary-header" }, [
                    _vm._v("\n            Payments\n          "),
                  ]),
                  _c("br"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Amount\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.refundInfo.amount))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Currency\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.refundInfo.currency))]),
                  ]),
                ]),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _vm._v(
        "\n      Take a quick look on the return summary before sending the return label "
      ),
      _c("br"),
      _vm._v(" to customer.\n    "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description description-no-label" }, [
      _vm._v(
        "\n      Take a quick look on the return summary before processing the return. "
      ),
      _c("br"),
      _vm._v(
        "\n      Note: the customer does not need to return the product(s), therefore no return label will be sent.\n    "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "24px" } }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "flex-1" }, [
          _vm._v("\n        Return Summary\n      "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }